var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "informacion-l",
    transform: "translate(99.5 99.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(-99.5 -99.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circulo",
    d: "M99.5,199h0c-31.7,0-56.3-8.2-73.2-24.5C8.9,157.7,0,132.5,0,99.5s8.9-58.2,26.3-75C43.2,8.2,67.8,0,99.5,0s56.3,8.2,73.2,24.5c17.5,16.8,26.3,42.1,26.3,75,0,33-8.9,58.2-26.3,75C155.8,190.8,131.2,199,99.5,199Zm0-193.3C69.3,5.7,46,13.4,30.2,28.6,13.9,44.3,5.7,68.1,5.7,99.5s8.3,55.2,24.6,71c15.7,15.2,39,22.9,69.3,22.9,30.2,0,53.5-7.7,69.3-22.9,16.3-15.7,24.6-39.6,24.6-71s-8.3-55.2-24.6-71C153,13.4,129.7,5.7,99.5,5.7Z",
    fill: "#019df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M99.8,148.6a2.8,2.8,0,0,1-2.8-2.8V74.2a2.8,2.8,0,0,1,5.6,0v71.6A2.8,2.8,0,0,1,99.8,148.6Z",
    fill: "#019df4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "punto",
    cx: 2.8,
    cy: 2.8,
    r: 2.8,
    transform: "translate(97 54.9)",
    fill: "#019df4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.43224d6040acb69b31fbc19508261e7b.svg";
export { ForwardRef as ReactComponent };